import PageFile from './src/page-file.vue'
export default PageFile
